<template>
    <div :class="['poll-tile', { 'poll-tile--large': isLarge }]">
        <div v-if="isLarge"
            class="poll-tile__partner"
        >
            <div class="poll-tile__partner-logo" />
            <div class="poll-tile__partner-shortname" />
            <div class="poll-tile__partner-name" />
        </div>

        <div class="poll-tile__labels">
            <div class="poll-tile__labels-icon" />
        </div>

        <div :class="['poll-tile__question', { 'poll-tile__question--bordered': isLarge }]" />

        <div v-if="isLarge"
            class="poll-tile__vote-status"
        >
            <div class="poll-tile__vote-status--icon" />
            <div class="poll-tile__vote-status--text" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'poll-tile-skeleton',
    props: {
        isLarge: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
.poll-tile {
    width: 26rem;
    height: 18rem;
    display: flex;
    flex-direction: column;
    background: $white-color;
    margin: 0.5rem 1rem 2rem;
    border-radius: 0.8rem;
    box-shadow: 0 1rem 1rem rgba($black-color, 0.08);
    padding: 2rem;

    @include max-width(sm) {
        width: 22rem;
        margin: 0;
    }

    &--large {
        flex-wrap: wrap;
        flex-direction: row;
        position: relative;
        width: 100%;
        height: auto;
        min-height: 14rem;
        padding-left: 8.5rem;
        padding-bottom: 0;
        margin: 2rem 1rem;
    }

    &__partner {
        @include min-width(md) {
            width: 50%;
        }

        &-logo {
            position: absolute;
            left: 2rem;
            width: 4.5rem;
            height: 4.5rem;
            margin-top: -0.25rem;
            background: $skeleton-gradient;
            border-radius: 100%;
        }

        &-shortname {
            height: 2rem;
            background: $skeleton-gradient;
            width: 7rem;
            border-radius: 2rem;
        }

        &-name {
            margin-top: 0.25rem;
            height: 2rem;
            background: $skeleton-gradient;
            width: 12rem;
            border-radius: 2rem;
        }
    }

    &__partner + &__labels {
        align-items: center;
        justify-content: flex-start;
        margin-top: 0.75rem;
        margin-bottom: -1.5rem;

        @include min-width(md) {
            margin: 0;
            width: 50%;
            justify-content: flex-end;
            order: initial;
        }
    }

    &__labels {
        display: flex;
        width: 100%;
        margin-bottom: 2rem;

        &-icon {
            margin-right: 0.8rem;
            border-radius: 0.4rem;
            height: 2.25rem;
            width: 9rem;
            display: flex;
            align-items: center;
            background: $skeleton-gradient;
        }
    }

    &__question {
        width: 100%;
        height: 1.7rem;
        line-clamp: 4;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        /* stylelint-disable */
        -webkit-box-orient: vertical;
        /* stylelint-enable */
        overflow: hidden;
        background: $skeleton-gradient;
        border-radius: 18px;

        &--bordered {
            border-top: 0.1rem solid $porcelain-color;
            border-bottom: 0.1rem solid $porcelain-color;
            margin-top: 3.5rem;
            display: flex;
            align-items: center;
            padding: 2rem 0;
        }
    }

    &__vote-status {
        display: flex;
        align-items: center;
        padding: 2rem 0;

        &--icon {
            height: 2.4rem;
            width: 2.4rem;
            margin-right: 0.5rem;
            background: $skeleton-gradient;
            border-radius: 0.5rem;
        }

        &--text {
            height: 2.4rem;
            width: 9rem;
            background: $skeleton-gradient;
            border-radius: 2rem;
        }
    }
}
</style>